import FiClock from '@meronex/icons/fi/FiClock';
import icon from './StyledIcon';
export default icon(FiClock);
